// `detail` de um erro da API às vezes é uma string (nossos HTTPException) e às vezes é uma
// lista de objetos {type, loc, msg, ...} — é assim que o FastAPI formata um 422 de validação
// do Pydantic (ex: senha curta demais, e-mail inválido). Renderizar `detail` direto num JSX
// quebra nesse segundo caso ("Objects are not valid as a React child"), então todo lugar que
// mostra erro de API deve passar por aqui em vez de acessar `err.response.data.detail` direto.
export function getErrorMessage(err, fallback = 'Ocorreu um erro. Tente novamente.') {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const mensagens = detail.map((item) => (typeof item === 'string' ? item : item?.msg)).filter(Boolean);
    if (mensagens.length) return mensagens.join(' ');
  }
  return fallback;
}
